import { useConfigsContext } from '@/context/ConfigsContext'
import { postLikeRoom, postUnlikeRoom, Room } from '@/services/cms'
import { useRouter } from 'next/navigation'
import { MouseEventHandler, useEffect, useOptimistic, useState, useTransition } from 'react'

export function useLikedRoom(roomId: Room['id'], href: string, initialIsLiked: Room['is_liked']) {
  const router = useRouter()
  const { store } = useConfigsContext()

  const htcToken = store?.credentials?.htcToken

  const [isLiked, setIsLiked] = useState(initialIsLiked)

  const [optimisticIsLiked, setOptimisticIsLiked] = useOptimistic(
    isLiked,
    (_, nextIsLiked: boolean) => nextIsLiked,
  )

  const [isLikePending, startLikeTransition] = useTransition()

  useEffect(() => {
    setIsLiked(initialIsLiked)
  }, [initialIsLiked])

  const handleClickLike: MouseEventHandler = (e) => {
    e.stopPropagation()
    // for the logged-in user
    if (htcToken) {
      if (isLikePending) return

      const nextIsLiked = !optimisticIsLiked

      startLikeTransition(async () => {
        setOptimisticIsLiked(nextIsLiked)

        try {
          const results = nextIsLiked
            ? await postLikeRoom(roomId, htcToken)
            : await postUnlikeRoom(roomId, htcToken)

          if (results?.status === 200) {
            setIsLiked(nextIsLiked)
          }
        } catch {
          setIsLiked(isLiked)
        }
      })
    } else {
      // guest flow
      router.push(href)
    }
  }

  return {
    isLiked: optimisticIsLiked,
    handleClickLike,
  }
}
